// extracted by mini-css-extract-plugin
export default {"sexSelector":"SexSelector_sexSelector__0l-n0","option":"SexSelector_option__yV1bQ","optionSelected":"SexSelector_optionSelected__o2zBy SexSelector_option__yV1bQ"};